import { Pipe, PipeTransform } from '@angular/core';
import { MailInfo } from '../model/mail-info.model';

@Pipe({
  name: 'deEmphasizeNonMainpart'
})
export class DeEmphasizeNonMainpartPipe implements PipeTransform {
  // メール本文の非重要行にweakクラスが付いたspanタグを付与する関数
  transform(value: string, mail: MailInfo, enable: boolean = true): any {
    if (value && enable) {
      const line_judge = JSON.parse(mail.important_line_judge);
      // 非重要行の行番号
      const nonMainPartLineNum = Object.keys(line_judge).filter(
        k => line_judge[k] === 0
      );
      const linesArray = value.split('\n').map((line, i) => {
        // 非重要行とループ中の行が同じ時
        if (nonMainPartLineNum.includes(String(i))) {
          line = line.replace(/(.*)/, '<span class="weak">$&</span>');
        }
        return line;
      });
      value = linesArray.join('\n');
      return value;
    }
    return value;
  }
}
